import { render, staticRenderFns } from "./MsgTip.vue?vue&type=template&id=65cc1cc5&"
import script from "./MsgTip.vue?vue&type=script&lang=js&"
export * from "./MsgTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports